import { RouteConfig } from 'vue-router';
const aiQuestionnaire: RouteConfig[] = [
  {
    path: '/aiIndex.html',
    name: 'aiIndex',
    component: () => import('@/views/AiQuestionnaire/aiIndex.vue'),
    meta: {
      title: '龙艺秀_免费在线收款制作平台',
    },
  },
  {
    path: '/aiResult.html',
    name: 'aiResult',
    component: () => import('@/views/AiQuestionnaire/aiResult.vue'),
    meta: {
      title: '龙艺秀_免费在线收款制作平台',
    },
  },
];
export { aiQuestionnaire };
